module.exports = __webpack_public_path__ + "img/young-791849_640.41d1ac9c.jpg";